import { ContentSection } from '@bw/apis/contentful';

export type ColorScheme = NonNullable<
	ContentSection<undefined>['fields']['colorScheme']
>;

type ColorMap = {
	[key in ColorScheme]: string;
};

const schemeToClassMap: ColorMap = {
	'Default (white)': 'default',
	'Deep Blue': 'emphasized',
	'Bright Yellow': 'emphasized-secondary',
	'Periwinkle Grey': 'soft-primary',
	Cream: 'soft-secondary',
};

export const schemeToClass = (scheme?: ColorScheme) => scheme ? schemeToClassMap[scheme] : '';